import { apiGet } from '@/shared/utils/requestBuilder';
import type { DatadogEmbedUrlResponse } from '../../types/plataforma';

export const plataformaEmbedUrlService = {
  getEmbedUrl: async (): Promise<DatadogEmbedUrlResponse> => {
    const response = await apiGet('/admin/platform/embed-url');
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error?.message ?? 'Erro ao carregar URL de embed do dashboard');
    }

    return data.data as DatadogEmbedUrlResponse;
  },
};
